// Pure helpers for displaying a buyer's Expression-of-Interest (EOI) status on the
// Succession partial-sales marketplace. Kept free of React/intl so they can be unit-tested.
//
// PartialSaleListingUser.status enum (app/models/partial_sale_listing_user.rb):
//   expressed_interest -> Pending Review (buyer expressed, seller hasn't acted)
//   interested         -> Approved       (seller approved; messaging unlocked)
//   not_interested     -> Declined       (no producer today; handled defensively)

// Find the current user's own interest row on a listing. Returns undefined when absent —
// e.g. right after an optimistic express-interest, which only flips current_user_is_an_interest
// without injecting a row. Ids come from as_json and may differ in JS type, so compare as strings.
export const findMyInterest = (listing, userId) =>
  ((listing && listing.partial_sale_listing_users) || []).find(
    (lu) => lu && lu.user && String(lu.user.id) === String(userId)
  );

// Map a status string to a stable badge key. Null/missing status (legacy rows and the
// post-express optimistic state) is treated as pending.
export const eoiStatusKey = (status) => {
  switch (status) {
    case 'interested':
      return 'approved';
    case 'not_interested':
      return 'declined';
    case 'expressed_interest':
    default:
      return 'pending';
  }
};

// The buyer may message the seller only once approved. Messaging a still-pending interest
// would self-approve it (create_chat_from_partial_sale_user flips expressed_interest ->
// interested), and a closed listing has no live conversation to start.
export const canMessageSeller = (statusKey, saleStatus) =>
  statusKey === 'approved' && saleStatus !== 'closed';
